import { Dispatch } from "react";
import { FilterBe, SelectedFilter } from "./filters";

export type Order = "asc" | "desc" | undefined;

export interface ListingState {
  order: Order;
  page: number;
  property: string;
  rowsPerPage: number;
  rowsSelected: Set<string>;
}
export interface ListingProps {
  filters?: (SelectedFilter | FilterBe)[];
  order?: Order;
  page?: number;
  rows?: number;
  sortKey?: string;
  dynamicSearch?: { query: string; value: string };
}

export interface Total {
  all?: number;
  estimated?: boolean;
  filtered?: number;
}

export interface ListResponse<T = any> {
  items: T[];
  total: Total;
}

export enum ListingActions {
  CHANGE_PAGE = "changePage",
  CHANGE_ROWS_PER_PAGE = "changeRowsPerPage",
  SELECT_ALL = "selectAll",
  SELECT_ROW = "selectRow",
  SET_SORT = "setSort",
  UNSELECT_ALL = "unselectAll",
  UNSELECT_ROW = "unselectRow",
}

type ChangePageAction = {
  payload: number;
  type: ListingActions.CHANGE_PAGE;
};

type ChangeRowsPerPageAction = {
  payload: number;
  type: ListingActions.CHANGE_ROWS_PER_PAGE;
};

type UnselectAllAction = {
  type: ListingActions.UNSELECT_ALL;
};

type SelectAllAction = {
  ids: Set<string>;
  type: ListingActions.SELECT_ALL;
};

type SelectRowAction = {
  id: string;
  type: ListingActions.SELECT_ROW;
};

type UnselectRowAction = {
  id: string;
  type: ListingActions.UNSELECT_ROW;
};

type SetSortAction = {
  payload: {
    order: Order;
    property: string;
    rowsPerPage: number;
    page: number;
    onSortCustomAction?: (
      order: Order,
      property: string,
      rowsPerPage: number,
      page: number,
    ) => void;
  };
  type: ListingActions.SET_SORT;
};

type Actions =
  | ChangePageAction
  | ChangeRowsPerPageAction
  | SelectAllAction
  | SelectRowAction
  | SetSortAction
  | UnselectAllAction
  | UnselectRowAction;

export type DispatchType = Dispatch<Actions>;
